<template>
  <refonte-modal
    v-bind:show="props.show"
    v-on:close="props.on_close"
    v-bind:title="props.title"
    class="!max-w-[640px]">
    <template v-slot:modalBody>
      <div class="flex flex-col gap-[12px]">
        <span v-if="props.show_body">
          La signature électronique de votre PIF a été initiée par votre
          cabinet.<br />
          Une fois que votre gestionnaire aura signé le document, vous recevrez
          automatiquement un email contenant le lien pour apposer votre propre
          signature.
        </span>
      </div>
    </template>
    <template v-slot:modalFooter>
      <refonte-button
        v-if="props.on_close"
        variant="primary"
        v-bind:on_click="props.on_close">
        Fermer
      </refonte-button>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      class?: string;
      title: string;
      show_body: boolean;
    }>(),
    {
      class: ''
    }
  );
</script>

<style lang="scss" scoped></style>
